// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kIAB","controls":"styles_controls__3WlcM","charLimit":"styles_charLimit__bVIhT","input":"styles_input__1AVaz","send":"styles_send__3JvLg"};